/* eslint-disable no-console */
import { LogLevel } from "@azure/msal-browser";
import config from "libs/config";

const msalConfig = {
	auth: {
		clientId: config.auth.appId,
		authority: `https://login.microsoftonline.com/${config.auth.tenantId}`,
		redirectUri: window.location.origin,
		postLogoutRedirectUri: `${window.location.origin}/public/logged-out`
	},
	cache: {
		cacheLocation: "sessionStorage",
		storeAuthStateInCookie: false
	},
	system: {
		loggerOptions: {
			loggerCallback: (level, message, containsPii) => {
				if (containsPii) {
					return;
				}

				switch (level) {
					case LogLevel.Error:
						console.error(message);
						break;

					case LogLevel.Info:
						break;

					case LogLevel.Verbose:
						break;

					case LogLevel.Warning:
						console.warn(message);
						break;

					default:
						console.error("Unsupported log level", message);
				}
			}
		}
	}
};

export default msalConfig;
